module.exports = __webpack_public_path__ + "static/media/001.4057dba8.jpg";